<np-footer
  [contentContactName]="'Ankit Gupta'"
  [contentContactUrl]="'mailto:ankit.gupta@chevron.com'"
  [technicalContactName]="'Srinivasreddy Velpula'"
  [technicalContactUrl]="'mailto:srinivasreddyvelpula@chevron.com'"
>
</np-footer>
